// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rendererIframeDiv{position:relative;height:92vh;margin-top:18px}", "",{"version":3,"sources":["webpack://./src/components/Renderer.scss"],"names":[],"mappings":"AAAA,mBACE,iBAAA,CACA,WAAA,CACA,eAAA","sourcesContent":[".rendererIframeDiv {\n  position: relative;\n  height: 92vh;\n  margin-top: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
